import React from 'react';
import { getShoppingItemsInScene } from 'ducks/products';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Flex from 'ui/Flex';
import Price from 'ui/Price/Price';
import Body from 'ui/Typography/Body';
import styled from 'styled-components';
import useIsRtl from 'hooks/useIsRtl';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import useFetchShoppingProducts from 'hooks/useFetchShoppingProducts';
import { ShoppingItemWithPrice } from '@inter-ikea-storageone/range';

export const calculateTotalPrice: (
  shoppingProducts: ShoppingItemWithPrice[]
) => number = shoppingProducts =>
  shoppingProducts.reduce(
    (acc: number, shoppingItem: ShoppingItemWithPrice) =>
      acc + shoppingItem.price * shoppingItem.quantity,
    0
  );

const StyledPrice = styled(Price)`
  font-size: ${({ theme }) => theme.space.l};
`;

const StyledPriceBody = styled(Body)`
  line-height: 1;
`;

const TotalPrice = () => {
  const { formatMessage } = useIntl();
  const productsInScene = useSelector(getShoppingItemsInScene);
  const { shoppingItemsWithPrice, shoppingItems } = useFetchShoppingProducts(productsInScene);
  const totalPrice = calculateTotalPrice(shoppingItemsWithPrice);
  const isRtl = useIsRtl();

  return (
    <Flex ml="auto" mr="md" flexDirection="column" alignItems={isRtl ? 'flex-start' : 'flex-end'}>
      <Body type={ThemeFontStyleTypeEnum.bodySmall}>
        {formatMessage({ id: 'storageone.totalPrice' })}
      </Body>
      <StyledPriceBody
        type={ThemeFontStyleTypeEnum.bodySmall}
        fontWeight="bold"
        data-testid="header-total-price"
        data-shoppingitems={JSON.stringify(shoppingItems)}
      >
        <StyledPrice animated amount={totalPrice} />
      </StyledPriceBody>
    </Flex>
  );
};

export default TotalPrice;
